"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSelectedFilterOption = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var interfaces_1 = require("../interfaces");
function normalizeSelectedFilterOption(selectedFilterOption) {
    if (interfaces_1.isUiRelativeDateFilterForm(selectedFilterOption) &&
        selectedFilterOption.from > selectedFilterOption.to) {
        return tslib_1.__assign(tslib_1.__assign({}, selectedFilterOption), { from: selectedFilterOption.to, to: selectedFilterOption.from });
    }
    return selectedFilterOption;
}
exports.normalizeSelectedFilterOption = normalizeSelectedFilterOption;
//# sourceMappingURL=FilterOptionNormalization.js.map